import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TrackingService } from '../../../services/tracking.service';
import { RenaultPuntoapuntoLocalCampaignOrderDataViewContentDTO } from 'src/app/models/renault-puntoapunto-local-campaign-order';

@Component({  
  templateUrl: './pap-local-campaign-viewer.component.html',
  styleUrls: ['./pap-local-campaign-viewer.component.scss']
})
export class PapLocalCampaignViewerComponent implements OnInit {

  idOrderData: string;
  model: RenaultPuntoapuntoLocalCampaignOrderDataViewContentDTO;
  htmlPrint: SafeHtml;

  constructor(private route: ActivatedRoute,
    private service: TrackingService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.idOrderData = this.route.snapshot.paramMap.get('id');

    if (this.idOrderData !== null) {
      this.service.ViewCrmPapEmail(this.idOrderData).subscribe(resp => {
        this.model = resp;
        this.htmlPrint = this.sanitizer.bypassSecurityTrustHtml(this.model.ContentHtml);
      });
    }

  }

}
